import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the buckets
 *
 * @returns {object} the result data
 */
export default async function getBuckets () {
  return await fetchJSONData(
    `${constants.API_URL}/partners/buckets?network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )
}
